<template>
  <div>
    <div class="my-3">
      <p v-if="grapesJSInstance !== null">
        Clicking on Select below will bring the selected link into your email campaign. First, enter text into your campaign; then highlight the text and click the Links button in editor. Click Select on the desired link you want, this will put the link on your text. Same process will be used if you want to put the link on a button (select the button in your campaign); then click Links button in editor. Click Select on the desired link you want, this will put the link on your button.
      </p>
      <p v-else>
        Clicking on Copy will add selected link to your clipboard. First, add a button into your existing campaign; then on the right hand side under action add the link url to the selected button, this will put the link on your button.
      </p>
    </div>
    <div class="d-flex justify-content-between">
      <button
        class="btn btn-lg btn-danger"
        tabindex="-1"
        @click="add"
      >
        Add new Global Link
      </button>
    </div>
    <div
      v-if="globalLinks.length"
      class="my-3"
    >
      <ejs-grid
        :data-source="globalLinks"
        :toolbar="toolbarOptions"
        :allow-paging="true"
        :allow-filtering="true"
        :page-settings="pageSettings"
        :filter-settings="filterOptions"
        :allow-sorting="true"
        clip-mode="EllipsisWithTooltip"
      >
        <e-columns>
          <e-column
            field=" "
            header-text=""
            width="80"
            :template="selectTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          />
          <e-column
            field="description"
            header-text="Description"
            width="130"
          />
          <e-column
            field="link"
            header-text="Link"
            width="120"
            :template="linkTemplate"
          />
          <e-column
            field=" "
            header-text=""
            width="80"
            :template="actionsTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          />
        </e-columns>
      </ejs-grid>
    </div>
    <BaseDialog
      ref="globalLinkAddModal"
      title="New Global Link"
      :custom-content-template="customContentTemplate"
      :show-close-icon="true"
      width="300px"
      height="250px"
    />
  </div>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { GridPlugin, Toolbar, Search, Page, Sort, Filter } from '@syncfusion/ej2-vue-grids'
import { createElement } from '@syncfusion/ej2-base'
import { TextBox } from '@syncfusion/ej2-inputs'
import GridSelect from './GridSelect'
import GridLink from './GridLink'
import GridActions from './GridActions'
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'
import BaseDialog from '@/components/Dialog/BaseDialog'
import GlobalLinkForm from './GlobalLinkForm'

Vue.use(GridPlugin)
MultiSelect.Inject(CheckBoxSelection)

export default {
  components: {
    BaseDialog
  },
  provide () {
    return {
      grid: [Toolbar, Search, Filter, Sort, Page],
      onClick: this.onSelect
    }
  },
  data () {
    return {
      pageSettings: { pageCount: 5, pageSize: 10, pageSizes: ['10', '25', '50', '100'] },
      filterOptions: {
        type: 'Menu',
        mode: 'OnEnter',
        operators: {
          stringOperator: [
            { value: 'startsWith', text: 'Starts With' },
            { value: 'endsWith', text: 'Ends With' },
            { value: 'contains', text: 'Contains' },
            { value: 'equal', text: 'Equal' }
          ]
        }
      },
      filter: {
        type: 'CheckBox'
      },
      toolbarOptions: ['Search'],
      customFilter: {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            this.dropInstance = new TextBox({
              placeholder: 'Enter the value'
            })
            this.dropInstance.appendTo(flValInput)
            this.$helpers.setFilterId(this.dropInstance.element)
          },
          write: (args) => {
            if (args.filteredValue) {
              this.dropInstance.value = args.filteredValue
            }
          },
          read: (args) => {
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value,
              false
            )
          }
        }
      },
      selectTemplate () {
        return {
          template: {
            extends: GridSelect
          }
        }
      },
      linkTemplate () {
        return {
          template: {
            extends: GridLink
          }
        }
      },
      actionsTemplate () {
        return {
          template: {
            extends: GridActions
          }
        }
      },
      customContentTemplate: GlobalLinkForm
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance',
      dynamicContent: 'getDynamicContent',
      globalLinks: 'getGlobalLinks'
    })
  },
  mounted () {
    const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
    this.getGlobalLinks({ userEmail })
  },
  methods: {
    ...mapActions([
      'getGlobalLinks'
    ]),
    add () {
      this.$store.commit('SET_GLOBAL_LINK_ON_EDITION', null)
      this.$refs.globalLinkAddModal.openDialog()
    },
    onSelect (link) {
      // if the grapeJS Instance is null, then copying the text for drag n drop
      if (this.grapesJSInstance === null) {
        this.legacyCopyToClipboard(link)
        this.dynamicContent.modalRef.closeDialog()
      } else {
        this.grapesJSInstance.InsertMoreOptData({
          action: 'InsertMoreOptData',
          type: 'link',
          value: link,
          moreoption: true
        })
        this.dynamicContent.modalRef.closeDialog()
      }
    },
    legacyCopyToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
      } catch (err) {
        console.error('Unable to copy to clipboard', err)
      }
      document.body.removeChild(textArea)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
